import React from 'react';

const Skills = () => {
    return (
        <section className=' flex flex-col align-middle justify-center' >
            <div id="skills" className=''>.</div>
            <div>
                <h3 className="text-3xl font-bold text-center">My Skills</h3>
                <h4 className="text-2xl font-bold mt-5">Expertise</h4>
                <p>HTML5, CSS3, Bootstrap, Tailwind CSS, Daisy Ui, JavaScript, React JS </p>
                <h4 className="text-2xl font-bold mt-5">Comfortable</h4>
                <p>MongoDB, Express JS, Node JS, Firebase Authentication, MySQL</p>
                <h4 className="text-2xl font-bold mt-5">Familliar</h4>
                <p>Redux, JWT, Stripe, Material UI </p>
                <h4 className="text-2xl font-bold mt-5">Tools</h4>
                <p>VS Code, Postman, Vercel, Atom, Code Blocks, Netbin</p>
                <h4 className="text-2xl font-bold mt-5">Programming Language</h4>
                <p>C, Python, Java, PHP, JavaScript</p>
            </div>
        </section>
    );
};

export default Skills;